import { render } from "./SubscriptionSuccess.vue?vue&type=template&id=2a165b01"
import script from "./SubscriptionSuccess.vue?vue&type=script&lang=js"
export * from "./SubscriptionSuccess.vue?vue&type=script&lang=js"
script.render = render

export default script